/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetTranscription200Response } from '../models';
/**
 * TranscriptionApi - axios parameter creator
 * @export
 */
export const TranscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 文字起こし取得API
         * @summary 文字起こし取得API
         * @param {number} callResultId transcription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscription: async (callResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callResultId' is not null or undefined
            assertParamExists('getTranscription', 'callResultId', callResultId)
            const localVarPath = `/api/user/call_results/{callResultId}/transcription`
                .replace(`{${"callResultId"}}`, encodeURIComponent(String(callResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranscriptionApi - functional programming interface
 * @export
 */
export const TranscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TranscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 文字起こし取得API
         * @summary 文字起こし取得API
         * @param {number} callResultId transcription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscription(callResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTranscription200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscription(callResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TranscriptionApi - factory interface
 * @export
 */
export const TranscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TranscriptionApiFp(configuration)
    return {
        /**
         * 文字起こし取得API
         * @summary 文字起こし取得API
         * @param {number} callResultId transcription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscription(callResultId: number, options?: any): AxiosPromise<GetTranscription200Response> {
            return localVarFp.getTranscription(callResultId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TranscriptionApi - interface
 * @export
 * @interface TranscriptionApi
 */
export interface TranscriptionApiInterface {
    /**
     * 文字起こし取得API
     * @summary 文字起こし取得API
     * @param {number} callResultId transcription ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionApiInterface
     */
    getTranscription(callResultId: number, options?: AxiosRequestConfig): AxiosPromise<GetTranscription200Response>;

}

/**
 * Request parameters for getTranscription operation in TranscriptionApi.
 * @export
 * @interface TranscriptionApiGetTranscriptionRequest
 */
export interface TranscriptionApiGetTranscriptionRequest {
    /**
     * transcription ID
     * @type {number}
     * @memberof TranscriptionApiGetTranscription
     */
    readonly callResultId: number
}

/**
 * TranscriptionApi - object-oriented interface
 * @export
 * @class TranscriptionApi
 * @extends {BaseAPI}
 */
export class TranscriptionApi extends BaseAPI implements TranscriptionApiInterface {
    /**
     * 文字起こし取得API
     * @summary 文字起こし取得API
     * @param {TranscriptionApiGetTranscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionApi
     */
    public getTranscription(requestParameters: TranscriptionApiGetTranscriptionRequest, options?: AxiosRequestConfig) {
        return TranscriptionApiFp(this.configuration).getTranscription(requestParameters.callResultId, options).then((request) => request(this.axios, this.basePath));
    }
}
